import AuthLayout from '../../../components/shared/AuthLayout';
import ResetPasswordForm from '../../../components/auth/ResetPasswordForm';
import { Link } from '@mui/material';

const ResetPasswordPage = () => {
  const sideImageUrl = "https://images.unsplash.com/photo-1579546929662-711aa81148cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80";

  return (
    <AuthLayout
      sideImageUrl={sideImageUrl}
      FormComponent={ResetPasswordForm}
      pageTitle="Set New Password"
      pageDescription="Create a strong new password to secure your account"
      sideTitle="Reset Your Password"
      sideSubtitle="Choose a strong, unique password to keep your account secure."
      additionalLink={
        <Link 
          href="/fmr/sign-in" 
          sx={{ 
            color: '#00ff88', 
            fontWeight: 600, 
            '&:hover': { 
              textDecoration: 'underline',
              color: '#66ffb3'
            } 
          }}
        >
          ← Back to Sign In
        </Link>
      }
    />
  );
};

export default ResetPasswordPage;